import type { ChangeEvent } from 'react'
import { useState } from 'react'
import { useSearch } from '@faststore/sdk'

import { OptionsMap } from './Sort'
import {
  IconMinusFilter,
  IconPlusFilter,
} from '../FilterV2/Accordion/utils/icons'

import './sortMobile.scss'

const MobileSort = () => {
  const [openTab, setOpenTab] = useState(false)
  const {
    setSort,
    state: { sort },
  } = useSearch()

  const sortkeys = Object.keys(OptionsMap) as Array<keyof typeof OptionsMap>

  const handleRadioClick = (e: ChangeEvent<HTMLInputElement>) => {
    setSort(e.target.value as keyof typeof OptionsMap)
  }

  return (
    <div className="border-b border-gray py-5 flex flex-col sm:hidden">
      <button
        className="flex justify-between items-center w-full header-tab-brands-filter"
        onClick={() => setOpenTab(!openTab)}
        aria-hidden={openTab}
      >
        <div className="flex flex-col gap-2">
          <span className="text-base text-restructure-primary font-medium font-inter text-left">
            Ordernar por
          </span>
          {!openTab && (
            <small className="text-xs text-tertiary font-normal font-inter text-left">
              {OptionsMap[sort as keyof typeof OptionsMap]}
            </small>
          )}
        </div>

        {openTab ? <IconMinusFilter /> : <IconPlusFilter />}
      </button>

      {openTab && (
        <div className="mt-4">
          <ul className="flex flex-col gap-6">
            {sortkeys.map((key) => {
              return (
                <li
                  key={key}
                  className="font-inter text-[#000] text-sm font-medium"
                >
                  <label className="flex items-center justify-start gap-3">
                    <input
                      type="radio"
                      name="sort"
                      value={key}
                      onChange={handleRadioClick}
                      checked={sort === key}
                      className="hidden sort-mobile-radio-input"
                    />
                    <span className="sort-mobile-radio" />
                    <span>{OptionsMap[key]}</span>
                  </label>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default MobileSort
